module.exports = "/images/veil-2.jpg";